// React
import React from 'react';
// Styles
import './styles.scss';
import OwnerDetailsForm from './OwnerDetailsForm/OwnerDetailsForm';
import PetDetailsForm from './PetDetailsForm/PetDetailsForm';
import getFormFieldVal from 'utils/getFormFieldVal';
import isEmpty from 'lodash/isEmpty';

class OwnerPetDetailsForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            bHasAutopopulated: !isEmpty(props.formData.pet.lastName),
        };
    }
    render() {
        return (
            <div>
                <OwnerDetailsForm 
                    ref={this.props.formComponent.owner}
                    formData={this.props.formData.owner}
                    hideForm={this.props.hideForm}
                    ownerDetailsDisabled={this.props.ownerPetDetailsDisabled}
                    onLastNameChange={e => {
                        // Stop if the last name has already been autopopulated once
                        if (this.state.bHasAutopopulated) {
                            return;
                        }

                        const strOwnerLastName = getFormFieldVal(e);

                        // Pass the changed owner last name to the last name change event handler in the PetDetailsForm component
                        this.props.formComponent.pet.current.onLastNameChange(strOwnerLastName['lastName']  ?? '');                        
                    }}
                    onAutoPopulate={e => {
                        this.setState({ bHasAutopopulated: true });
                    }}
                    ></OwnerDetailsForm>
                <hr />
                <PetDetailsForm 
                    ref={this.props.formComponent.pet} 
                    formData={this.props.formData.pet}
                    bookingImage={this.props.formData.bookingImage}
                    class="pet-form"
                    petDetailsDisabled={this.props.ownerPetDetailsDisabled}
                    isEdit={this.props.isEdit}
                    petWeightEditable={this.props.petWeightEditable}
                ></PetDetailsForm>   
                <div className="required-fields-label">* Required Fields</div>
            </div>
        );
    }
}

export default OwnerPetDetailsForm;
